/**
 * SideNavMenuItem.tsx — underlenke i side-nav meny
 *
 * Ren React-komponent som erstatter cds-side-nav-menu-item.
 * Bruker next/link for ruting.
 *
 * Props:
 * - href: rute-lenke
 * - children: lenketekst
 */

import Link from 'next/link';
import styles from './side-nav-menu-item.module.css';

interface SideNavMenuItemProps {
  href: string;
  children: React.ReactNode;
}

export default function SideNavMenuItem({ href, children }: SideNavMenuItemProps) {
  return (
    <li className={styles.item}>
      <Link href={href} className={styles.link}>
        {children}
      </Link>
    </li>
  );
}
